var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"article"},[_c('h3',[_vm._v(_vm._s(_vm.article.title))]),_c('h5',[_vm._v(_vm._s(_vm.article.publishDate))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.postHtml)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }